<template>

  <!-- 教师专业发展综合积分排行榜 -->
  <div class="top1">
    <h1>教师专业发展综合积分排行榜：
      <span
        v-if="!isScoreMore"
        class="fr"
        @click="checkMore"
      >
        查看更多&nbsp;<i class="el-icon-arrow-right el-icon--right"></i>
      </span>
    </h1>
    <div class="big-box clearfix">

      <div
        v-for="(item,index) in listData"
        :key="index"
        :index="index"
        class="box fl"
        @click="goDetail(item.teacherId,item.totalScore)"
      >
        <div class="tit">
          <div class="fl">
            <img
              :src="item.userLogo ? item.userLogo : defaultUrl"
              alt=""
            >
          </div>
          <div class="name fl">
            <div class="clearfix">
              <h2 class="fl">{{item.teacherName}}</h2>
              <i
                class="iconfont icon-paimingbiaoqian fr paiming-icon"
                :class="['icon-color'+index]"
              >
                <span class="num">{{pageObj.size*(pageObj.current-1) + index+1}}</span>
              </i>
            </div>
            <span>{{item.des}}</span>
          </div>

        </div>
        <div class="tu">
          <div
            style="width:100%;height:100%"
            class="chart-class"
            ref="chart"
          ></div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <pagination
      v-if="isScoreMore"
      :pageObj="pageObj"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>
  </div>

</template>

<script>
import { mapState } from "vuex";
import Pagination from "@/components/Pagination.vue";
export default {
  components: {
    Pagination,
  },
  props: {
    isDetail: false,
    isScoreMore: false,
    searchYear: "",
    searchTerm: "",
    searchKey: "",
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      listData: [],
      defaultUrl: require(`@/assets/image/other/headMan.png`),
      pageObj: {
        current: 1,
        total: 0,
        size: 4,
        sizeList: [4, 8 ,12],
      },
    };
  },
  created() {
    this.rankLsit(1, 4);
  },
  methods: {
    //教师专业发展综合积分排行榜
    rankLsit(curPage, pageSize) {
      let homeForm = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        keyword: this.searchKey || "",
      };
      this.$axios
        .post("/rpt/getTeacherRankList", homeForm)
        .then((res) => {
          if (res.resultCode === 200 && res.data.records.length > 0) {
            this.handleData(res.data.records);
            this.$nextTick(() => {
              this.initCharts();
            });
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
          } else {
           this.listData = [];
          }
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    handleData(data) {
      this.listData = data;
      this.listData.forEach((item, index) => {
        item.resData = [
          // { value: Math.ceil(Math.random() * 100), name: "学" },
          // { value: Math.ceil(Math.random() * 100), name: "奖" },
          // { value: Math.ceil(Math.random() * 100), name: "获" },
          // { value: Math.ceil(Math.random() * 100), name: "学生" },
          // { value: Math.ceil(Math.random() * 100), name: "获奖" },
          // { value: Math.ceil(Math.random() * 100), name: "学生获奖" },
          { value: 100, name: "学" },
          { value: 150, name: "奖" },
          { value: 90, name: "获" },
          { value: 170, name: "学生" },
          { value: 80, name: "获奖" },
          { value: 100, name: "学生获奖" },
        ];
        item.des = (item.teachingAge || "0年") + "教龄," + (item.academicTitlesDesc || "职称未评");
      });
    },
    initCharts() {
      for (let i = 0; i < this.listData.length; i++) {
        let myChart = this.$echarts.init(this.$refs.chart[i]);
        myChart.setOption({
          color: [
            "#1890FF",
            "#13C2C2",
            "#2FC25B",
            "#FACC14",
            "#F04864",
            "#8543E0",
          ],
          title: [
            {
              text: "综合得分",
              x: "47.5%",
              y: "32%",
              textAlign: "center",
              textStyle: {
                fontSize: "15",
                fontWeight: "100",
                color: "#b3b2b2",
                textAlign: "center",
              },
            },
            {
              text: this.listData[i].totalScore + "分",
              x: "47.5%",
              y: "47%",
              textAlign: "center",
              textStyle: {
                fontSize: "25",
                fontWeight: "400",
                color: "#36CB8C",
                textAlign: "center",
              },
            },
          ],
          series: [
            {
              //空白间隙
              itemStyle: {
                normal: {
                  borderColor: "#FFF",
                  borderWidth: 1,
                },
              },
              name: "综合得分",
              type: "pie",
              radius: ["50%", "70%"],
              avoidLabelOverlap: false,
              //不显示每一项的介绍
              label: {
                show: false,
                position: "center",
              },
              //触摸显示中间的标题
              // emphasis: {
              //   label: {
              //     show: false,
              //     fontSize: "30",
              //     fontWeight: "bold",
              //   },
              // },
              labelLine: {
                show: false,
              },
              data: this.listData[i].resData,
            },
          ],
        });
      }
    },
    checkMore() {
      this.$emit("scoreMore");
      this.$nextTick(() => {
        // 新增节点后，结构全部渲染后,才能拿到最后的chart节点
        this.pageObj.size=8;
        this.rankLsit(1);
      });
    },
    goDetail(teacherId,score) {
      this.$emit("goDetail",teacherId,score);
    },

    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.rankLsit(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.rankLsit(curPage);
    },
  },
};
</script>

<style lang="less" scoped>
.top1 {
  h1 {
    // border: 1px solid #000;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    color: @theme-color;
    span {
      width: 130px;
      padding: 0px 20px;
      // border: 1px solid #000;
      cursor: pointer;
      font-size: 14px;
      color: @theme-color;
      i {
        font-size: 16px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        line-height: 19px;
        text-align: center;
        color: rgb(253, 250, 250);
        background-color: @theme-color;
      }
    }
  }
  .big-box {
    margin-top: 15px;
    .box {
      cursor: pointer;
      width: 278px;
      height: 282px;
      margin-bottom: 24px;
      box-sizing: border-box;
      margin-right: 24px;
      background: #fff;
      border-radius: 7px;
      padding: 20px 24px;
      .tit {
        height: 76px;
        border-bottom: 1px solid rgb(216, 209, 209);
        img {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          // border: 1px solid rgb(223, 212, 212);
        }
        .name {
          margin-left: 10px;
          width: 150px;
          h2 {
            font-size: 24px;
            font-weight: 700;
            height: 38px;
            width: 120px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden; /** 隐藏超出的内容 **/
            line-height: 38px;
          }
          .paiming-icon {
            font-size: 27px;
            color: #e6e6e6;
            position: relative;
            top: 0;
            left: 0;
            .num {
              position: absolute;
              transform: translate(-50%, -50%);
              top: 40%;
              left: 50%;
              color: #000;
            }
          }
          .icon-color0 {
            color: #ff7250;
            .num {
              color: #fff;
            }
          }
          .icon-color1 {
            color: #ffaa00;
            .num {
              color: #fff;
            }
          }
          .icon-color2 {
            color: #597ef7;
            .num {
              color: #fff;
            }
          }
          span {
            color: #000000;
            opacity: 0.45;
            font-size: 14px;
          }
        }
      }
      .tu {
        width: 100%;
        height: 180px;
        margin-top: 5px;
      }
    }
  }
}
</style>
